import { $ } from "@/plug/Axios";

export default {
  /**
   * 期末考试发布
   */
  examPublish_confirmForClient: {
    /*
     * C端确认通知
     * ids ids (array query required)
     */
    put: (p, c) =>
      $.put("/api/ems/examination/examPublish/confirmForClient", p, c)
  },
  examPublish_confirmForTeacher: {
    /*
     * 管理端班主任确认通知
     * ids ids (array query required)
     */
    put: (p, c) =>
      $.put("/api/ems/examination/examPublish/confirmForTeacher", p, c)
  },
  examPublish_detailList: {
    /*
     * 详情-考试发布数据
     * id ID (integer query required)
     */
    get: (p, c) => $.get("/api/ems/examination/examPublish/detailList", p, c)
  },
  examPublish_exportStudent: {
    /*
     * 导出-考试发布数据-考务
     */
    get: (p, c) => $.get("/api/ems/examination/examPublish/exportStudent", p, c)
  },
  examPublish_exportStudentForService: {
    /*
     * 服务管理导出
     */
    get: (p, c) =>
      $.get("/api/ems/examination/examPublish/exportStudentForService", p, c)
  },
  examPublish_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/examination/examPublish/list", p, c)
  },
  examPublish_listCourse: {
    /*
     * 考试科目列表
     * id ID (integer query required)
     */
    get: (p, c) => $.get("/api/ems/examination/examPublish/listCourse", p, c)
  },
  examPublish_listSimple: {
    /*
     * 简易考试列表
     */
    get: (p, c) => $.get("/api/ems/examination/examPublish/listSimple", p, c)
  },
  examPublish_listSimpleCampus: {
    /*
     * 简易考区列表
     * examId 考试ID (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/examination/examPublish/listSimpleCampus", p, c)
  },
  examPublish_listStudent: {
    /*
     * 列表-考试发布数据-考务
     */
    get: (p, c) => $.get("/api/ems/examination/examPublish/listStudent", p, c)
  },
  examPublish_listStudentForService: {
    /*
     * 服务管理-线下考试学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/examination/examPublish/listStudentForService", p, c)
  },
  examPublish_publish: {
    /*
     * 发布
     * id ID (integer query required)
     * publishStatus 发布或未发布 (string query )
     */
    post: (p, c) => $.post("/api/ems/examination/examPublish/publish", p, c)
  },
  examPublish_remove: {
    /*
     * 删除考试
     * id ID (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/examination/examPublish/remove", p, c)
  },
  examPublish_removeMaterial: {
    /*
     * 删除复习资料-考试科目列表
     * id 考试科目列表返回的ID (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/examination/examPublish/removeMaterial", p, c)
  },
  examPublish_removeStudent: {
    /*
     * 删除学生
     * id ID (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/examination/examPublish/removeStudent", p, c)
  },
  examPublish_save: {
    /*
     * 添加编辑
     * creatorId 创建人 (integer query )
     * id  (integer query )
     * name 通知名称 (string query )
     * noticeExamCampus 需要通知的考区 (string query )
     * publishStatus 发布状态 (string query )
     * publishTime 发布时间 (string query )
     * siteId 学校ID (integer query )
     * tagId 企微标签ID (string query )
     */
    post: (p, c) => $.post("/api/ems/examination/examPublish/save", p, c)
  },
  examPublish_saveMaterial: {
    /*
     * 添加复习资料-考试科目列表
     * examId examId (integer query required)
     * reviewMaterialsId reviewMaterialsId (integer query required)
     * teachingProgramIds teachingProgramId (array query required)
     */
    post: (p, c) =>
      $.post("/api/ems/examination/examPublish/saveMaterial", p, c)
  },
  examPublish_searchByClient: {
    /*
     * C端-查询通知
     */
    get: (p, c) =>
      $.get("/api/ems/examination/examPublish/searchByClient", p, c)
  },
  examPublish_searchByTeacher: {
    /*
     * 管理端-查询通知
     * schoolRollId 合同编号 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/examination/examPublish/searchByTeacher", p, c)
  },
  examPublish_searchTeachingProgramId: {
    /*
     * 根据科目名称查询teachingProgramId
     * examId examId (integer query required)
     * level 层次（导入命名规则，课程名字-层次-后面随意） (string query )
     * teachingProgramName 课程名称（导入命名规则，课程名字-层次-后面随意） (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/examination/examPublish/searchTeachingProgramId", p, c)
  },
  examPublish_uploadArrange: {
    /*
     * 导入考试安排
     * excelFile excelFile (file formData required)
     * id ID (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/examination/examPublish/uploadArrange", p, c)
  },

  /**
   * 线下考试
   */
  offline_check: {
    /*
     * 验证数据
     * id ID (integer query required)
     */
    put: (p, c) => $.put("/api/ems/examination/offline/check", p, c)
  },
  offline_exportExamCards: {
    /*
     * 获取准考证、桌贴
     * examCampusList 考区 (array query required)
     * examId 考试ID (integer query required)
     */
    get: (p, c) => $.get("/api/ems/examination/offline/exportExamCards", p, c)
  },
  offline_exportSignInData: {
    /*
     * 获取签到表数据
     * examCampusList 考区 (array query required)
     * examId 考试ID (integer query required)
     */
    get: (p, c) => $.get("/api/ems/examination/offline/exportSignInData", p, c)
  },
  offline_getPackageCover: {
    /*
     * 获取试卷袋封面数据
     * examCampusList 考区 (array query required)
     * examId 考试ID (integer query required)
     */
    get: (p, c) => $.get("/api/ems/examination/offline/getPackageCover", p, c)
  },
  offline_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/examination/offline/list", p, c)
  },
  offline_listExamWayCard: {
    /*
     * 获取门贴
     * examCampusList 考区 (array query required)
     * examId 考试ID (integer query required)
     */
    get: (p, c) => $.get("/api/ems/examination/offline/listExamWayCard", p, c)
  },
  offline_listSimple: {
    /*
     * 简易考试列表
     */
    get: (p, c) => $.get("/api/ems/examination/offline/listSimple", p, c)
  },
  offline_listSimpleCampus: {
    /*
     * 简易考区列表
     * examId 考试ID (integer query )
     */
    get: (p, c) => $.get("/api/ems/examination/offline/listSimpleCampus", p, c)
  },
  offline_remove: {
    /*
     * 删除考试
     * id ID (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/examination/offline/remove", p, c)
  },
  offline_save: {
    /*
     * 添加编辑
     * id ID (integer query )
     * name 名称 (string query required)
     */
    post: (p, c) => $.post("/api/ems/examination/offline/save", p, c)
  },
  offline_uploadArrange: {
    /*
     * 导入考试安排
     * excelFile excelFile (file formData required)
     * id ID (integer query required)
     */
    post: (p, c) => $.post("/api/ems/examination/offline/uploadArrange", p, c)
  },

  /**
   * 线下考试学生
   */
  offlineStudent_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/examination/offlineStudent/export", p, c)
  },
  offlineStudent_list: {
    /*
     * 考务管理-列表
     */
    get: (p, c) => $.get("/api/ems/examination/offlineStudent/list", p, c)
  },
  offlineStudent_remove: {
    /*
     * 删除学生-考务管理
     * id ID (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/examination/offlineStudent/remove", p, c)
  },

  /**
   * 线上考试
   */
  online_answerForClient: {
    /*
     * C端-提交考试大难
     * beforeExamCheckingPhoto 考前身份核验照片 (string query )
     * firstAnswerPhoto 答卷照片1 (string query required)
     * handlePaperPhoto 手持答题卷照片 (string query )
     * id 我的考试列表ID (integer query required)
     * secondAnswerPhoto 答卷照片2 (string query )
     * thirdAnswerPhoto 答卷照片3 (string query )
     */
    put: (p, c) => $.put("/api/ems/examination/online/answerForClient", p, c)
  },
  online_batchAssign: {
    /*
     * 批量分配监考老师
     * ids 列表IDs (array query required)
     * invigilatorId 监考老师ID (integer query required)
     */
    put: (p, c) => $.put("/api/ems/examination/online/batchAssign", p, c)
  },
  online_clearExam: {
    /*
     * 打回重考
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/examination/online/clearExam", p, c)
  },
  online_detail: {
    /*
     * 详情
     * id 列表ID (integer query required)
     */
    get: (p, c) => $.get("/api/ems/examination/online/detail", p, c)
  },
  online_downloadMould: {
    /*
     * 下载模版
     */
    get: (p, c) => $.get("/api/ems/examination/online/downloadMould", p, c)
  },
  online_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/examination/online/export", p, c)
  },
  online_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/examination/online/list", p, c)
  },
  online_listForClient: {
    /*
     * C端-我的考试列表
     * finishStatus 完成状态（已完成|未完成） (string query required)
     */
    get: (p, c) => $.get("/api/ems/examination/online/listForClient", p, c)
  },
  online_listInvigilator: {
    /*
     * 简单监考老师列表
     */
    get: (p, c) => $.get("/api/ems/examination/online/listInvigilator", p, c)
  },
  online_remove: {
    /*
     * 删除
     * id 列表ID (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/examination/online/remove", p, c)
  },
  online_update: {
    /*
     * 编辑
     * beforeExamCheckingPhoto 考前身份核验照片 (string query )
     * dingGroupNo 所在钉钉群 (string query required)
     * endTime 考试结束时间 (string query required)
     * firstAnswerPhoto 答卷照片1 (string query required)
     * handlePaperPhoto 手持答题卷照片 (string query )
     * id 行ID (integer query required)
     * onlyAnswerFlag 是否只需要提交答卷照片 (string query )
     * secondAnswerPhoto 答卷照片2 (string query )
     * startTime 考试开始时间 (string query required)
     * thirdAnswerPhoto 答卷照片3 (string query )
     */
    put: (p, c) => $.put("/api/ems/examination/online/update", p, c)
  },
  online_upload: {
    /*
     * 批量导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/examination/online/upload", p, c)
  },

  /**
   * 在线虚拟作业
   */
  onlineWork: {
    /*
     * 添加
     * id id (integer query )
     * title 作业题目 (string query required)
     */
    post: (p, c) => $.post("/api/ems/examination/onlineWork", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/examination/onlineWork", p, c)
  },
  onlineWork_downloadMould: {
    /*
     * 下载导入学生模板
     */
    get: (p, c) => $.get("/api/ems/examination/onlineWork/downloadMould", p, c)
  },
  onlineWork_exportRecord: {
    /*
     * 导出作业记录列表
     */
    get: (p, c) => $.get("/api/ems/examination/onlineWork/exportRecord", p, c)
  },
  onlineWork_finishWork: {
    /*
     * 生成学生作业
     * id id (integer query required)
     * reCreate 是否重新生成 (string query required)
     * recordId 记录ID,单个生成传入 (integer query )
     */
    post: (p, c) => $.post("/api/ems/examination/onlineWork/finishWork", p, c)
  },
  onlineWork_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/examination/onlineWork/list", p, c)
  },
  onlineWork_listRecord: {
    /*
     * 学生作业记录列表
     */
    get: (p, c) => $.get("/api/ems/examination/onlineWork/listRecord", p, c)
  },
  onlineWork_listReference: {
    /*
     * 模版列表
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/examination/onlineWork/listReference", p, c)
  },
  onlineWork_removeRecord: {
    /*
     * 删除记录
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/examination/onlineWork/removeRecord", p, c)
  },
  onlineWork_removeReference: {
    /*
     * 删除模版
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/examination/onlineWork/removeReference", p, c)
  },
  onlineWork_saveRecord: {
    /*
     * 单个添加学生
     * id id (integer query required)
     * schoolRollId 合同编号 (integer query required)
     */
    post: (p, c) => $.post("/api/ems/examination/onlineWork/saveRecord", p, c)
  },
  onlineWork_saveReference: {
    /*
     * 添加模版范文
     * fileUrl 文件地址 (string query )
     * id  (integer query )
     * name  (string query )
     * onlineWorkId 在线作业id (integer query )
     */
    post: (p, c) =>
      $.post("/api/ems/examination/onlineWork/saveReference", p, c)
  },
  onlineWork_syncSignature: {
    /*
     * 同步签名
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/examination/onlineWork/syncSignature", p, c)
  },
  onlineWork_uploadRecord: {
    /*
     * 导入学生
     * excelFile excelFile (file formData required)
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/ems/examination/onlineWork/uploadRecord", p, c)
  },

  /**
   * 成绩排名
   */
  score_rank_exportForEdu: {
    /*
     * 考务管理-排名列表导出
     */
    get: (p, c) => $.get("/api/ems/examination/score/rank/exportForEdu", p, c)
  },
  score_rank_exportForService: {
    /*
     * 服务管理-排名列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/examination/score/rank/exportForService", p, c)
  },
  score_rank_listForEdu: {
    /*
     * 考务管理-成绩排名列表
     */
    get: (p, c) => $.get("/api/ems/examination/score/rank/listForEdu", p, c)
  },
  score_rank_listForService: {
    /*
     * 服务管理-成绩排名列表
     */
    get: (p, c) => $.get("/api/ems/examination/score/rank/listForService", p, c)
  },
  score_rank_test: {
    /*
     * 测试定时任务
     */
    post: (p, c) => $.post("/api/ems/examination/score/rank/test", p, c)
  },

  /**
   * 自考成绩
   */
  selfTaughtScore_downloadMould: {
    /*
     * 下载模版
     */
    get: (p, c) =>
      $.get("/api/ems/examination/selfTaughtScore/downloadMould", p, c)
  },
  selfTaughtScore_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/examination/selfTaughtScore/export", p, c)
  },
  selfTaughtScore_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/examination/selfTaughtScore/list", p, c)
  },
  selfTaughtScore_listScore: {
    /*
     * 根据合同编号查询成绩
     * examBatch 考期 (string query )
     * passStatus 是否已通过:0未通过，1通过 (integer query )
     * schoolRollId 合同编号 (integer query required)
     */
    get: (p, c) => $.get("/api/ems/examination/selfTaughtScore/listScore", p, c)
  },
  selfTaughtScore_listUnpassedCourse: {
    /*
     * 未通过课程
     * schoolRollId 合同编号 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/examination/selfTaughtScore/listUnpassedCourse", p, c)
  },
  selfTaughtScore_refreshCredits: {
    /*
     * 刷新学分
     */
    put: (p, c) =>
      $.put("/api/ems/examination/selfTaughtScore/refreshCredits", p, c)
  },
  selfTaughtScore_remove: {
    /*
     * 删除
     * id 列表ID (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/examination/selfTaughtScore/remove", p, c)
  },
  selfTaughtScore_update: {
    /*
     * 编辑
     * examBatch 考期 (string query )
     * id  (integer query )
     * majorCourseId 专业课程ID (integer query )
     * operatorId 录入人 (integer query )
     * schoolRollId 合同编号 (integer query )
     * score 考试成绩 (string query )
     */
    put: (p, c) => $.put("/api/ems/examination/selfTaughtScore/update", p, c)
  },
  selfTaughtScore_upload: {
    /*
     * 导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/examination/selfTaughtScore/upload", p, c)
  },

  /**
   * 成绩管理
   */
  studentScore_applyChecking: {
    /*
     * 申请复查
     * id 列表ID (integer query required)
     * reason 复查原因 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/examination/studentScore/applyChecking", p, c)
  },
  studentScore_auditChecking: {
    /*
     * 处理复查
     * id 复查列表ID (integer query required)
     * offlineExamScore 修改后考试成绩 (number query )
     * resitExamScore 修改后补考成绩 (number query )
     * result 处理结果 (string query required)
     * totalScore 修改后总成绩 (number query )
     */
    put: (p, c) =>
      $.put("/api/ems/examination/studentScore/auditChecking", p, c)
  },
  studentScore_batchPublish: {
    /*
     * 批量发布
     * ids 列表ID (array query required)
     * publishStatus 发布状态（已发布未发布） (string query required)
     */
    put: (p, c) => $.put("/api/ems/examination/studentScore/batchPublish", p, c)
  },
  studentScore_downloadMould: {
    /*
     * 下载模版
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentScore/downloadMould", p, c)
  },
  studentScore_exportForEdu: {
    /*
     * 考务管理-成绩管理列表导出
     */
    get: (p, c) => $.get("/api/ems/examination/studentScore/exportForEdu", p, c)
  },
  studentScore_exportForService: {
    /*
     * 服务管理-成绩管理列表导出
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentScore/exportForService", p, c)
  },
  studentScore_getBySchoolRollId: {
    /*
     * 根据合同编号查询成绩管理列表
     * schoolRollId 合同编号 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentScore/getBySchoolRollId", p, c)
  },
  studentScore_listCheckingRecord: {
    /*
     * 成绩复查记录列表
     * id 列表ID (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentScore/listCheckingRecord", p, c)
  },
  studentScore_listForEdu: {
    /*
     * 考务管理-成绩管理列表
     */
    get: (p, c) => $.get("/api/ems/examination/studentScore/listForEdu", p, c)
  },
  studentScore_listForService: {
    /*
     * 服务管理-成绩管理列表
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentScore/listForService", p, c)
  },
  studentScore_listStudentScoreForExport: {
    /*
     * 导出成绩档案-杭商院
     * majorId 专业ID (integer query )
     * rollGrade 学习年级 (string query )
     * siteId 学校ID (integer query required)
     * term 学期 (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentScore/listStudentScoreForExport", p, c)
  },
  studentScore_publish: {
    /*
     * 发布
     * id 列表ID (integer query required)
     * publishStatus 发布状态（已发布未发布） (string query required)
     */
    put: (p, c) => $.put("/api/ems/examination/studentScore/publish", p, c)
  },
  studentScore_remove: {
    /*
     * 删除
     * ids 列表IDS (array query required)
     */
    delete: (p, c) => $.delete("/api/ems/examination/studentScore/remove", p, c)
  },
  studentScore_schoolStudentScoreExport: {
    /*
     * 导出高校成绩单-班级
     * checkAdmin 复核人（学校温职需要，湖师毕业成绩册显示负责人） (string query )
     * commitAdmin 登记人（学校温职需要, 学校湖师默认传登录人名字，学校商职显示任课老师） (string query )
     * examTime 年月日，（商职、温职显示考试时间、计量显示批卷时间 湖工大显示填报时间） (string query )
     * majorId 专业ID (integer query )
     * rollGrade 学习年级 (string query required)
     * siteId 学校ID (integer query required)
     * siteName 学校 (string query required)
     * studyEnd 学习结束时间（年月日，学校湖师需要） (string query )
     * studyStart 学习开始时间（年月日，学校湖师需要） (string query )
     * subType 类型：班级成绩单|班级学习成绩单（商职） 班级成绩单|班级成绩册|毕业成绩册(湖师) (string query )
     * term 学期 (integer query )
     * termCN 学期:春季学期|秋季学期, 湖工大 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentScore/schoolStudentScoreExport", p, c)
  },
  studentScore_schoolStudentScoreExportCard: {
    /*
     * 导出高校学生成绩卡（湖工大|农林|计量|温职|商职|工商|旅职职业）-个人
     * commitAdmin 经办人（学校商职需要） (string query )
     * examTime 年月日（湖工大、旅职显示为制表时间, 工商职业显示为毕业时间， 湖师显示打印时间） (string query )
     * majorId 专业ID (integer query required)
     * rollGrade 学习年级 (string query required)
     * siteId 学校ID (integer query required)
     * siteName 学校 (string query required)
     * term 学期 (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/ems/examination/studentScore/schoolStudentScoreExportCard",
        p,
        c
      )
  },
  studentScore_searchForClient: {
    /*
     * C端我的期末考试成绩列表
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentScore/searchForClient", p, c)
  },
  studentScore_update: {
    /*
     * 编辑
     * id 列表ID (integer query required)
     * offlineExamScore 考试成绩 (number query )
     * reportTeacher 指导老师 (string query )
     * reportTitle 实习报告或毕设题目 (string query )
     * resitExamScore 补考成绩 (number query )
     * studyHours 学时 (string query )
     * studyType 学习类型,key=专业学习类型 (string query )
     * totalScore 总成绩 (number query )
     * usualScore 平时成绩 (number query )
     * workScore 作业成绩 (number query )
     */
    put: (p, c) => $.put("/api/ems/examination/studentScore/update", p, c)
  },
  studentScore_upload: {
    /*
     * 批量上传
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/examination/studentScore/upload", p, c)
  },

  /**
   * 学生签到
   */
  studentSignature_batchClear: {
    /*
     * 批量清空签到
     * ids ID (array query )
     */
    put: (p, c) =>
      $.put("/api/ems/examination/studentSignature/batchClear", p, c)
  },
  studentSignature_delay: {
    /*
     * 批量延期
     * endTime 签到结束时间 (string query required)
     * siteId 学校 (integer query required)
     */
    put: (p, c) => $.put("/api/ems/examination/studentSignature/delay", p, c)
  },
  studentSignature_downloadMould: {
    /*
     * 下载模版
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentSignature/downloadMould", p, c)
  },
  studentSignature_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/examination/studentSignature/export", p, c)
  },
  studentSignature_exportExcel: {
    /*
     * 导出签到表
     * endTime 签到结束时间 (string query )
     * headerTeacherId 班主任 (integer query )
     * majorIds 专业ID,多选 (array query )
     * rollGrade 学籍年级 (string query )
     * siteId 学校ID (integer query required)
     * startTime 签到开始时间 (string query )
     * studyDateEnd 上课日期结束 (string query )
     * studyDateStart 上课日期开始 (string query )
     * studyTimeList 具体时间（key） (array query )
     * term 学期 (integer query )
     * year 年份 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentSignature/exportExcel", p, c)
  },
  studentSignature_exportExcelForXGD: {
    /*
     * 导出签到表-西工大
     * endTime 签到结束时间 (string query )
     * headerTeacherId 班主任 (integer query )
     * majorIds 专业ID,多选 (array query )
     * rollGrade 学籍年级 (string query )
     * siteId 学校ID (integer query required)
     * startTime 签到开始时间 (string query )
     * studyDateEnd 上课日期结束 (string query )
     * studyDateStart 上课日期开始 (string query )
     * studyTimeList 具体时间（key） (array query )
     * term 学期 (integer query )
     * year 年份 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentSignature/exportExcelForXGD", p, c)
  },
  studentSignature_getForClient: {
    /*
     * 学生端-我的列表
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentSignature/getForClient", p, c)
  },
  studentSignature_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/examination/studentSignature/list", p, c)
  },
  studentSignature_listSimpleSite: {
    /*
     * 简单学校列表
     */
    get: (p, c) =>
      $.get("/api/ems/examination/studentSignature/listSimpleSite", p, c)
  },
  studentSignature_remove: {
    /*
     * 删除
     * ids ID (array query )
     */
    delete: (p, c) =>
      $.delete("/api/ems/examination/studentSignature/remove", p, c)
  },
  studentSignature_signatureForClient: {
    /*
     * 学生端-学生签到
     * id detail列表ID (integer query required)
     * signatureUrl 签到地址 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/examination/studentSignature/signatureForClient", p, c)
  },
  studentSignature_update: {
    /*
     * 编辑
     * address 上课地点 (string query required)
     * endTime 签到结束时间 (string query required)
     * id 行ID (integer query required)
     * roomNo 教室号 (string query required)
     * startTime 签到开始时间 (string query required)
     * status 学生签到状态 (string query required)
     * studyDate 上课日期（仅年月日） (string query required)
     * studyTime 具体时间（上午或下午） (string query required)
     * teacherName 任课老师 (string query required)
     */
    put: (p, c) => $.put("/api/ems/examination/studentSignature/update", p, c)
  },
  studentSignature_upload: {
    /*
     * 批量导入
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/examination/studentSignature/upload", p, c)
  },

  /**
   * 作业发布
   */
  work_addModelFile: {
    /*
     * 批量上传作业附件-学历教育-教学教务-作业发布
     * level 层次 (string query )
     * modelFileId modelFileId (integer query required)
     * siteId siteId (integer query required)
     * teachingProgramName 文件名称（课程名称命名） (string query required)
     */
    post: (p, c) => $.post("/api/ems/examination/work/addModelFile", p, c)
  },
  work_commitForClient: {
    /*
     * C端提交作业
     * answer 答案 (string query required)
     * id 查询返回的ID (integer query required)
     */
    post: (p, c) => $.post("/api/ems/examination/work/commitForClient", p, c)
  },
  work_export: {
    /*
     * 导出-学历教育-教学教务-作业发布
     */
    get: (p, c) => $.get("/api/ems/examination/work/export", p, c)
  },
  work_exportStudent: {
    /*
     * 导出-学历教育-教学教务-作业发布详情
     */
    get: (p, c) => $.get("/api/ems/examination/work/exportStudent", p, c)
  },
  work_exportStudentForService: {
    /*
     * 导出-学历教育-教学教务-作业发布详情
     */
    get: (p, c) =>
      $.get("/api/ems/examination/work/exportStudentForService", p, c)
  },
  work_getDetail: {
    /*
     * 交卷详情(阅卷也可调用)-学历教育-教学教务-作业发布详情
     * schoolRollId schoolRollId (integer query required)
     * workId workId (integer query required)
     */
    get: (p, c) => $.get("/api/ems/examination/work/getDetail", p, c)
  },
  work_list: {
    /*
     * 列表-学历教育-教学教务-作业发布
     */
    get: (p, c) => $.get("/api/ems/examination/work/list", p, c)
  },
  work_listStudent: {
    /*
     * 列表-学历教育-教学教务-作业发布详情
     */
    get: (p, c) => $.get("/api/ems/examination/work/listStudent", p, c)
  },
  work_listStudentForService: {
    /*
     * 列表-学历教育-教学教务-作业发布详情
     */
    get: (p, c) =>
      $.get("/api/ems/examination/work/listStudentForService", p, c)
  },
  work_over: {
    /*
     * 批阅-学历教育-教学教务-作业发布详情
     * id ID (integer query required)
     * score 得分 (number query required)
     */
    post: (p, c) => $.post("/api/ems/examination/work/over", p, c)
  },
  work_publish: {
    /*
     * 发布作业或成绩-学历教育-教学教务-作业发布
     * ids ID (array query required)
     * publishStatus 已发布或未发布 (string query )
     * type 类型：作业或成绩 (string query required)
     */
    post: (p, c) => $.post("/api/ems/examination/work/publish", p, c)
  },
  work_refuse: {
    /*
     * 打回（可重新提交作业）-学历教育-教学教务-作业发布详情
     * id ID (integer query required)
     */
    post: (p, c) => $.post("/api/ems/examination/work/refuse", p, c)
  },
  work_remove: {
    /*
     * 删除-学历教育-教学教务-作业发布
     * id ID (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/examination/work/remove", p, c)
  },
  work_removeStudent: {
    /*
     * 删除单个学生-学历教育-教学教务-作业发布详情
     * id ID (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/examination/work/removeStudent", p, c)
  },
  work_save: {
    /*
     * 添加编辑-学历教育-教学教务-作业发布
     * deadline 提交截止时间 (string query required)
     * id id (integer query )
     * majorIds 专业（多选） (array query )
     * modelFileId 附件 (integer query )
     * rollGrade 学籍年级 (string query required)
     * terms 学期（多选） (array query )
     * title 题目 (string query )
     */
    post: (p, c) => $.post("/api/ems/examination/work/save", p, c)
  },
  work_searchForClient: {
    /*
     * C端登录查询
     */
    get: (p, c) => $.get("/api/ems/examination/work/searchForClient", p, c)
  },
  work_updateDeadline: {
    /*
     * 批量编辑截止时间-学历教育-教学教务-作业发布
     * deadline 提交截止时间 (string query required)
     * ids ID (array query required)
     */
    post: (p, c) => $.post("/api/ems/examination/work/updateDeadline", p, c)
  },
  work_updateOverAdmin: {
    /*
     * 修改阅卷老师-学历教育-教学教务-作业发布
     * ids IDs (array query required)
     * overAdminId 批阅人 (integer query required)
     */
    post: (p, c) => $.post("/api/ems/examination/work/updateOverAdmin", p, c)
  }
};
